import React from "react";
import ServicesComponent from "../modules/servicescopy";

function Services(props) {
  
  return <ServicesComponent {...props}  />;
}

export default Services;